import * as React from "react";
import "intersection-observer";
import { Action, IOWidget, any, mk_pair, mk_widget } from "widgets-for-react";
import { CMSState } from "../../../../cms/blocks/types.gen";
import { PublicSite_CustomPageData } from "../../../application.mod";
import {
  BrochureWebshopState,
  brochuresWidget,
} from "../../../templates/BrochuresWebshop/brochuresWebshop.widget";
import { PublicSiteState } from "../../../../public_site.main.mod";

export type BrochuresBlockProps = {
  block_index: number;
  title: string;
  selected_language: number;
  selected_term: number;
  language_name: string;
  language: number;
  topic: number;
  topic_name: string;
  showLanguageFilter: boolean;
  showSubjectFilter: boolean;
  description: string;
  isDownload: boolean;
  state: BrochureWebshopState;
};

export type BrochuresBlockStyle = Partial<{}>;

export function BrochuresBlock<CustomBlockData, extra_images>(
  props: BrochuresBlockProps,
  options?: { key?: string }
): (
  s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>
) => IOWidget<
  PublicSiteState,
  Action<CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>>
> {
  return (
      s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>
    ) =>
    (public_state: PublicSiteState) =>
      mk_widget({
        run: (set_state) => (
          <section
            className="block block--brochures brs"
            key={options && options.key ? options.key : "brochure-block"}
          >
            <div className="brs__inner container container--m gutter--m spacing--m">
              {brochuresWidget(props).run((future_state) => {
                let new_state = future_state(props.state);

                set_state((s) => {
                  let currentBlock = s.blocks.get(props.block_index) as any;
                  if (currentBlock.kind === "brochuresBlock") {
                    currentBlock = {
                      ...currentBlock,
                      value: mk_pair(
                        {
                          ...currentBlock.value.fst,
                          state: { ...new_state, route_state: "none" },
                        },
                        currentBlock.value.snd
                      ),
                    };
                  }
                  return {
                    ...s,
                    blocks: s.blocks.set(props.block_index, currentBlock),
                  };
                });
              })}
            </div>
          </section>
        ),
      });
}
